export const styles = {
  pdfIcon: {
    position: 'relative',
    width: '88px',
    height: '88px',
    div: {
      display: 'none',
    },
    'a:hover + div': {
      display: 'block',
    },
  },
  title: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '50%',
    backgroundColor: 'rgba(0,0,0,0.3)',
    pointerEvents: 'none',
    color: '#FFF',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '500',
    textWrap: 'wrap',
    wordWrap: 'break-word',
    //overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
  },
}
